import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";
import React from "react";

const HolidayStructureDetailsTable = ({
    dataList,
    clickSubmitHandler,
    onChangeRadioGroup,
}) => {

    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {

            let isValid = false;
            let holidayName =
                currentRow.holidayName != null ? currentRow.holidayName : "";
            let dayForTable =
                currentRow.dayForTable != null ? currentRow.dayForTable : "";
            let monthName =
                currentRow.monthName != null ? currentRow.monthName : "";

            if (
                holidayName &&
                holidayName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                dayForTable &&
                dayForTable.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                monthName &&
                monthName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={onSearchValue}
            />

            <div
                style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "500px",
                    position: "relative",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    <thead
                        style={{
                            position: "sticky",
                            top: 0,
                            background: "#03a9f4",
                            zIndex: 3,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <tr>

                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "100px",
                                }}
                            >
                                Sr. No
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "230px", }}>
                                Holiday
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "190px", }}>
                                Day
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px", }}>
                                Month
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                Holiday Type
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getFilteredTableData(dataList).map((dataObj, index) => (
                            <tr key={dataObj.id}>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                    }}
                                >
                                    {dataObj.index !== null ? dataObj.index : ""}
                                </td>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "left",
                                    }}
                                >
                                    {dataObj.holidayName !== null ? dataObj.holidayName : ""}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    {dataObj.dayForTable !== null ? dataObj.dayForTable : ""}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "left" }}>
                                    {dataObj.monthName !== null ? dataObj.monthName : ""}
                                </td>
                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "center" }}>
                                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                        <RadioGroup
                                            row
                                            value={dataObj.holidayType}
                                            onChange={(e) => onChangeRadioGroup(e, dataObj.id)}
                                        >
                                            <FormControlLabel value={0} control={<Radio size="small" />} label="Fixed" />
                                            <FormControlLabel value={1} control={<Radio size="small" />} label="Optional" />
                                            <FormControlLabel value={2} control={<Radio size="small" />} label="NA" />
                                        </RadioGroup>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <br />
            <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="flex-end"
                gap={2}
            >
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Submit"}
                    onClick={clickSubmitHandler}
                    fullWidth={false}
                />
            </Grid>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HolidayStructureDetailsTable);
